<template>
  <div class="fin-drawer-backdrop" style="align-items: flex-start; justify-content: center" @click.self="$emit('close')">
    <div class="fin-modal">
      <div class="fin-drawer-head">
        <div>
          <div class="fin-drawer-title">Importo skedar</div>
          <div class="fin-drawer-sub">Skedari perdoret vetem per te filtruar listen. Asgje nuk ruhet ne sistem.</div>
        </div>
        <button type="button" class="fin-btn" @click="$emit('close')"><i class="fa fa-times"></i> Mbyll</button>
      </div>

      <div class="fin-drawer-body">
        <div class="fin-field" style="margin-bottom: 14px">
          <label>Lloji i importit</label>
          <div class="fin-segmented">
            <button type="button" :class="{ active: type === 'product' }" @click="setType('product')">Sipas produktit</button>
            <button type="button" :class="{ active: type === 'warehouse' }" @click="setType('warehouse')">Sipas magazinës</button>
          </div>
          <p class="fin-hint">{{ hint }}</p>
        </div>

        <label class="fin-file-picker" :class="{ disabled: loading }">
          <input type="file" accept=".csv,.txt,.xls,.xlsx" :disabled="loading" @click="$event.target.value = null" @change="onFilePicked" />
          <span class="fin-file-picker-btn">Zgjidh skedarin</span>
          <span class="fin-file-name">{{ fileName || "CSV, XLS ose XLSX - një kolonë me kode" }}</span>
        </label>

        <div v-if="loading" class="fin-loading"><i class="fa fa-circle-notch fa-spin"></i> Duke lexuar skedarin...</div>

        <div v-if="error" class="fin-warn" style="margin-top: 14px">
          <i class="fa fa-triangle-exclamation" style="margin-top: 2px"></i>
          <span>{{ error }}</span>
        </div>

        <template v-if="result && !loading">
          <div class="fin-summary-row" style="margin-top: 14px">
            <div class="fin-summary-card">
              <div class="fin-summary-icon" style="background: #ecfdf5; color: #047857"><i class="fa fa-check"></i></div>
              <div>
                <div class="fin-summary-value">{{ result.matched.length }}</div>
                <div class="fin-summary-label">{{ type === "warehouse" ? "Magazina të gjetura" : "Produkte të gjetura" }}</div>
              </div>
            </div>
            <div class="fin-summary-card">
              <div class="fin-summary-icon" style="background: #fef2f2; color: #b91c1c"><i class="fa fa-question"></i></div>
              <div>
                <div class="fin-summary-value">{{ result.unmatched.length }}</div>
                <div class="fin-summary-label">Kode që nuk u gjetën</div>
              </div>
            </div>
          </div>

          <div v-if="result.truncated" class="fin-warn">
            <i class="fa fa-triangle-exclamation" style="margin-top: 2px"></i>
            <span>Skedari kishte më shumë se 5000 kode. U morën vetëm 5000 të parët.</span>
          </div>

          <template v-if="result.matched.length">
            <p class="fin-drawer-section-title" style="margin-top: 14px">Të gjetura</p>
            <table class="fin-mini-table">
              <thead>
                <tr>
                  <th>Kodi</th>
                  <th>Emri</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in result.matched.slice(0, 50)" :key="row.guid">
                  <td>{{ row.code }}</td>
                  <td>{{ row.name }}</td>
                </tr>
              </tbody>
            </table>
            <p v-if="result.matched.length > 50" class="fin-hint">... dhe {{ result.matched.length - 50 }} të tjera.</p>
          </template>

          <template v-if="result.unmatched.length">
            <p class="fin-drawer-section-title">Nuk u gjetën</p>
            <div class="fin-chips">
              <span v-for="code in result.unmatched.slice(0, 40)" :key="code" class="fin-chip muted">{{ code }}</span>
            </div>
            <p v-if="result.unmatched.length > 40" class="fin-hint">... dhe {{ result.unmatched.length - 40 }} të tjera.</p>
          </template>
        </template>
      </div>

      <div class="fin-modal-foot">
        <button type="button" class="fin-btn" @click="$emit('close')">Anullo</button>
        <button type="button" class="fin-btn primary" :disabled="!canApply" @click="apply">
          <i class="fa fa-filter"></i>
          Apliko filtrin ({{ result ? result.matched.length : 0 }})
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FinancaStockService from "@/services/FinancaStock";

export default {
  name: "FinancaImportModal",
  emits: ["close", "apply"],
  data() {
    return {
      type: "product",
      fileName: "",
      loading: false,
      error: "",
      result: null,
    };
  },
  computed: {
    canApply() {
      return !this.loading && this.result && this.result.matched.length > 0;
    },
    hint() {
      return this.type === "warehouse"
        ? "Skedari duhet të ketë kodet (ose emrat) e magazinave. Magazinat e gjetura zgjidhen automatikisht në filtër."
        : "Skedari duhet të ketë kodet (ose barkodet) e produkteve. Lista filtrohet vetëm te këto produkte.";
    },
  },
  methods: {
    setType(type) {
      if (this.type === type) return;
      this.type = type;
      this.result = null;
      this.error = "";
      this.fileName = "";
    },
    async onFilePicked(event) {
      const file = event?.target?.files?.[0];
      if (!file) return;

      this.fileName = file.name;
      this.loading = true;
      this.error = "";
      this.result = null;

      try {
        this.result = await FinancaStockService.resolveImport(file, this.type);
        if (!this.result.matched.length) {
          this.error = "Asnjë nga kodet e skedarit nuk u gjet në sistem.";
        }
      } catch (err) {
        this.error = err?.response?.data?.message || "Skedari nuk u lexua dot.";
      } finally {
        this.loading = false;
      }
    },
    apply() {
      if (!this.canApply) return;
      this.$emit("apply", { type: this.result.type, guids: this.result.guids, matched: this.result.matched });
    },
  },
};
</script>
